import React from "react";
import CustomModal from "./Modals/CustomModal";
import { Col, Row, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { formatNumber } from "src/utils/formatting";
import CustomButton from "./CustomButton";

interface FillLevelExplanationModalProps{
    show: boolean;
    onClose: () => void;
    grainDepthAtCenter: number | null,
    grainDepthAtPerimeter: number | null,
    bushelsFull: number | null,
    percentFull: number | null,
    parentRef?: React.RefObject<HTMLElement>;
}

const { Text, Title } = Typography; 

const FillLevelExplanationModal: React.FC<FillLevelExplanationModalProps> = ({ show, onClose, grainDepthAtCenter, grainDepthAtPerimeter, bushelsFull, percentFull, parentRef }) => {

    return(
        <CustomModal 
        show={show} 
        onClose={onClose}       
        title={'Fill Level Info'}
        parentRef={parentRef}
        >
            <Row justify='center'>
                <Col span={18}>
                    <Row>
                        <Text><span style={{fontWeight:'bold'}}>{formatNumber(grainDepthAtCenter, {
                            decimalPlaces: 1,
                            suffix: "'"
                        })} center</span> - Grain depth at the center of the bin</Text>
                    </Row>
                    <Row>
                        <Text><span style={{fontWeight:'bold'}}>{formatNumber(grainDepthAtPerimeter, {
                            decimalPlaces: 1,
                            suffix: "'"
                        })} perimeter</span> - Grain depth near the bin wall</Text>
                    </Row>
                    <Row>
                        <Text><span style={{fontWeight:'bold'}}>{formatNumber(bushelsFull, {
                            decimalPlaces: 0,
                            suffix: " bu"
                        })}</span> - Estimated bushels in the bin</Text>
                    </Row>
                    <Row>
                        <Text><span style={{fontWeight:'bold'}}>{formatNumber(percentFull, {
                            decimalPlaces: 1,
                            suffix: "%"
                        })} FILL</span> - Approximate % of the bin that's filled</Text>
                    </Row>
                </Col>
            </Row>
            <br/>
            <Row justify={'end'}>
                <CustomButton variant='secondary' label={'Close'} icon={<CloseOutlined/>} onClick={onClose}/>
            </Row>
        </CustomModal>
    )
}

export default FillLevelExplanationModal;